import React from 'react';
import DiferencaComissaoService from '../../../../lib/api/diferencaComissao/diferencaComissao';
import TemplateParametro from '../shared/templateParametros/templateParametros';

class ParametroDiferencaComissao extends React.Component<{}, {}> {
	constructor(props: any) {
		super(props);
		this.state = {};
	}

	baixarParametrosExcel = () => {
		return DiferencaComissaoService.baixarParametrosExcel();
	}

	reenviarParametrosExcel = () => {
		return DiferencaComissaoService.reenviarParametrosExcel();
	}

	render() {
		return (
			<TemplateParametro
				enviarParametrosEventGrid={this.reenviarParametrosExcel}
				baixarExcelParametros={this.baixarParametrosExcel}
				enviarExcelParametros={DiferencaComissaoService.salvarParametrosExcel}
				deletarExcelParametros={DiferencaComissaoService.deletarParametrosExcel}
				nomeDoArquivo='Parametro Diferenca Comissao'
			/>
		);
	}
}

export default ParametroDiferencaComissao;